// src/components/SupportModal.jsx
import React, { useState } from "react";
import CustomModal from "../../utils/CustomModal";
import { toast } from "react-toastify";
import { userService } from "../../services/userService";
import "../../styles/CustomModal.css";

const SupportModal = ({ isOpen, isClose, onClose, user }) => {
  const closeModal = onClose || isClose;
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const userId = user?.id;
    if (!userId) {
      toast.error("Unable to identify your account. Please log in again.");
      return;
    }
    if (!message.trim()) {
      toast.error("Please enter a message.");
      return;
    }
    setSending(true);
    try {
      await userService.sendSupportMessage({ userId, message: message.trim() });
      toast.success("Support request sent successfully!");
      setMessage("");
      closeModal();
    } catch (error) {
      console.error(error);
      toast.error(error.message || "Failed to send support request.");
    } finally {
      setSending(false);
    }
  };

  return (
    <CustomModal isOpen={isOpen} onClose={closeModal} modalTitle="Contact Support">
      <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-4">
        <div className="flex flex-col">
          <label className="text-sm font-medium mb-1">Email</label>
          <input
            type="email"
            value={user?.email || ""}
            readOnly
            className="border rounded-lg px-2 py-1 text-sm bg-gray-50 text-gray-500 cursor-not-allowed"
          />
        </div>

        <div className="flex flex-col">
          <label className="text-sm font-medium mb-1">Message</label>
          <textarea
            name="message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
            rows={5}
            placeholder="Describe your issue…"
            className="border rounded-lg px-2 py-1 text-sm"
          />
        </div>

        <button
          type="submit"
          disabled={sending}
          className="w-full bg-blue-500 hover:bg-blue-600 disabled:bg-blue-300 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors"
        >
          {sending ? "Sending…" : "Send"}
        </button>
      </form>
    </CustomModal>
  );
};

export default SupportModal;
